module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', [_vm._v("Requisição")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v(" "), (_vm.workflow.customizations.mailContact) ? _c('h5', [_vm._v("Caso haja dúvidas entrar em contato com o e-mail "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.workflow.customizations.mailContact
    }
  }, [_vm._v(_vm._s(_vm.workflow.customizations.mailContact))]), _vm._v(".")]) : _vm._e(), _vm._v(" "), (_vm.showRequestsButton) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.seeRequests
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-eye-open"
  }), _vm._v(" Ver Requisições Associadas")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.workflow.description)
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('loader')], 1), _vm._v(" "), _c('steps', {
    attrs: {
      "steps": _vm.steps,
      "editable": false,
      "icons": false,
      "groups": []
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sections.length > 0),
      expression: "sections.length > 0"
    }]
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentFormFields.length > 0),
      expression: "currentFormFields.length > 0"
    }]
  }, [_vm._l((_vm.summary), function(fields, sectionId, i) {
    return (_vm.showSummary) ? _c('div', {
      key: sectionId,
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h4', [_vm._v(_vm._s(i + 1) + ". " + _vm._s(_vm.getSection(sectionId).name))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((fields), function(formField) {
      return _c('div', {
        key: formField.objectId,
        staticClass: "form-group"
      }, [(formField.type !== 'separator') ? _c('label', {
        staticClass: "control-label",
        attrs: {
          "for": formField.objectId
        }
      }, [_vm._v("\n                  " + _vm._s(formField.name)), (formField.required) ? _c('span', {
        staticClass: "required"
      }, [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (formField.description) ? _c('p', {
        staticClass: "text-muted field-desc",
        domProps: {
          "innerHTML": _vm._s(formField.description)
        }
      }) : _vm._e(), _vm._v(" "), _c('dynamic-form-field', {
        attrs: {
          "formField": formField,
          "showSummary": true
        }
      })], 1)
    }), 0)]) : _vm._e()
  }), _vm._v(" "), (!_vm.showSummary) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "form-fields"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.currentFormFields), function(formField) {
    return _c('div', {
      key: formField.objectId,
      staticClass: "form-group",
      class: {
        'has-error': formField.invalid
      }
    }, [(formField.type !== 'separator') ? _c('label', {
      staticClass: "control-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n                  " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), (formField.type === 'file' && formField.type === 'document') ? _c('span', {
      staticClass: "upload-limit"
    }, [_vm._v("(tamanho máx. 50mb)")]) : _vm._e()]) : _c('h3', [_vm._v(_vm._s(formField.name))]), _vm._v(" "), (formField.description) ? _c('p', {
      staticClass: "text-muted field-desc",
      domProps: {
        "innerHTML": _vm._s(formField.description)
      }
    }) : _vm._e(), _vm._v(" "), _c('dynamic-form-field', {
      attrs: {
        "formField": formField,
        "showSummary": _vm.showSummary,
        "onChange": _vm.onChange
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (formField.invalid),
        expression: "formField.invalid"
      }],
      staticClass: "help-block"
    }, [_vm._v("O campo deve ser preenchido corretamente")])], 1)
  }), 0)]) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.back
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  }), _vm._v(" Voltar")]), _vm._v(" "), (_vm.showSummary === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.canReachNext
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Próximo "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })]) : _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "id": "btn-open-request"
    },
    on: {
      "click": _vm.saveRequest
    }
  }, [_vm._v("Finalizar "), _c('span', {
    staticClass: "glyphicon glyphicon-ok"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldsInstances.length),
      expression: "!fieldsInstances.length"
    }]
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O Tipo de Requisição escolhido ainda não possui campos para preenchimento.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Voltar")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sections.length),
      expression: "!sections.length"
    }]
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O Tipo de Requisição escolhido ainda não possui seções.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Voltar")])])])], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ask-repeat",
      "height": 'auto'
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h3', [_vm._v("Deseja continuar adicionando informações sobre " + _vm._s(_vm.currentSection() ? _vm.currentSection().name : '') + "?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.answerRepeat(true)
      }
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.answerRepeat(false)
      }
    }
  }, [_vm._v("Não, ir para próxima seção.")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52d9716e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestForm.vue
// module id = 1450
// module chunks = 1